<div *ngIf="isShoppingFunnel">
  <div class="text-center mb-3 clr-white" *ngIf="modePro">
    <div class="titi-web fs-30p screenMax500fs-15p">Vous êtes <span class="proOrganiser">organisateur d'évènement</span></div>
    <div class="fs-22p screenMax500fs-15p">Accéder à votre compte organisateur</div>
  </div>
  <div class="row d-flex justify-content-center">
    <div class="large1 pd6-85p" [ngClass]="{'col-md-5': !full, 'col-md-12': full}">
      <form (ngSubmit)="onSubmit(loginForm.valid)" #loginForm="ngForm">
        <div class="form-group row has-danger" *ngIf="errorMsg">
          <div class="col-12">
            <div class="form-control-feedback"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ errorMsg }}</div>
          </div>
        </div>
        <!-- email field -->
        <div class="form-group row" [ngClass]="{'has-danger':  email.errors && (email.dirty || email.valid || errorMsg) }">
          <div class="col-12 rp-xs">
            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
              <!--<div class="input-group-addon"><i class="fa fa-envelope" aria-hidden="true"></i></div>-->
              <input class="form-control placeholder-custum heigh-50 border-radius-none" type="email" value="" id="email" name="email" placeholder="E-mail" [(ngModel)]="credentials.email" #email="ngModel" required email>
            </div>
            <div class="form-control-feedback" *ngIf="email.touched && (email.dirty && credentials.email.length <= 0)"><i class="fa fa-info-circle" aria-hidden="true"></i> adresse mail requis</div>
            <div class="form-control-feedback" *ngIf="email.touched && email.errors && credentials.email.length > 0"><i class="fa fa-info-circle" aria-hidden="true"></i> adresse mail invalid</div>
          </div>
        </div>
        <!-- password field -->
        <div class="form-group row" [ngClass]="{'has-danger':  password.errors && (password.dirty || password.valid || errorMsg)}">
          <div class="col-12 rp-xs">
            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
              <!--<div class="input-group-addon"><i class="fa fa-lock" aria-hidden="true"></i></div>-->
              <input class="form-control placeholder-custum heigh-50 border-radius-none" [type]="hidePassword?'password':'text'" value="" id="password" name="password" placeholder="{{'shared_login_form.password'| translate}}" [(ngModel)]="credentials.password"  #password="ngModel"  required>
              <i class="fa fa-eye input-icon" *ngIf="hidePassword" (click)="toglePasswordVisibility()"></i>
              <i class="fa fa-eye-slash input-icon" aria-hidden="true" *ngIf="!hidePassword" (click)="toglePasswordVisibility()"></i>
            </div>
            <div class="form-control-feedback" *ngIf="password.touched && credentials.password.length <= 0"><i class="fa fa-info-circle" aria-hidden="true"></i> {{'shared_login_form.your_password_is_required'| translate}}</div>
          </div>
        </div>
        <!-- submit button -->
        <div class="form-group row submit-button-wrapper m-t-8p">
          <div class="rp-xs offset-sm-1 col-sm-10 text-center">
            <button type="submit" class="max-500-min-width-o mt-25p mt-mini pointer lgn-btn clr-white max-500-p-mini btn-color">{{'shared_login_form.LOG_IN'| translate}}</button>
          </div>
        </div>
      </form>
      <div *ngIf="modePro" class="center mt-30p">
        <span class="clr-white uppercase subscribe fs-12p-mini">vous n'avez pas encore créer de compte  ?
          <span class="link-color"> <a routerLink="/login/signup">inscrivez-vous</a></span>
        </span>
      </div>
      <div *ngIf="displayLinks && !modePro" class="displayLinks row">
        <div class="col-6 rp-xs">
          <div class="my-3 text-left"><a routerLink="/login/forgot">{{'shared_login_form.forgot_password'| translate}}</a></div>
        </div>
        <div class="col-6 rp-xs">
          <div class="my-3 text-right"><a routerLink="/login/signup">{{'shared_login_form.create_an_account'| translate}}</a></div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-7 message-orga serif" *ngIf="displayLinks && !modePro">
    <div class="color-blue font-size-22-768">{{'shared_login_form.you_organize_event'| translate}}</div>
    <h5><span class="color-blue font-size-22-768">{{'shared_login_form.create_account'| translate}}</span>
      <a href="//pro.akces.fr/landing/pro" class="blue2 font-size-22-768">pro.akces.fr</a>
      <span class="color-blue font-size-22-768"> {{'shared_login_form.in_some_clicks'| translate}} </span>
      <span class="blue2">{{'shared_login_form.its_simple_fast'| translate}}</span> </h5>
  </div>
</div>

<div *ngIf="!isShoppingFunnel" class="row col-md-12 pd-lr-0 mlr-0">

  <div class="col-md-4 bloc-h-mini pd-lr-0 bg">
     <div class="center pd-100p">
      <a href="/"> <img style="width: 250px" src="assets/imgs/{{logoName}}" alt="Logo Akces" id="logo"></a>
    </div>
     <div class="event-made-f-u">Des <span style="color: #00CCFF!important;">évènements</span> qui n'attendent que vous </div>
     <div class="login-bloc">
       <div class="acces_ur_account">Accédez a votre espace personnel</div>
         <form (ngSubmit)="onSubmit(loginForm.valid)" #loginForm="ngForm">
          <div class="form-group row has-danger" *ngIf="errorMsg">
            <div class="col-12">
              <div class="form-control-feedback"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ errorMsg }}</div>
            </div>
          </div>
          <!-- email field -->
          <div class="form-group row" [ngClass]="{'has-danger':  email.errors && (email.dirty || email.valid || errorMsg) }">
            <div class="col-12 rp-xs">
              <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                <!--<div class="input-group-addon"><i class="fa fa-envelope" aria-hidden="true"></i></div>-->
                <input class="form-control placeholder-custum heigh-50 border-radius-none" type="email" value="" id="email" name="email" placeholder="E-MAIl" [(ngModel)]="credentials.email" #email="ngModel" required email>
              </div>
              <div class="form-control-feedback" *ngIf="email.touched && email.dirty && credentials.email.length<=0"><i class="fa fa-info-circle" aria-hidden="true"></i> {{'shared_login_form.your_mail_adress_is_required_or_invalide'| translate}}</div>
              <!--<div class="form-control-feedback" *ngIf="email.touched && !email.valid && credentials.email.length>0 "><i class="fa fa-info-circle" aria-hidden="true"></i> {{'shared_login_form.your_mail_adress_is_invalid'| translate}}</div>-->
            </div>
          </div>
          <!-- password field -->
          <div class="form-group row" [ngClass]="{'has-danger':  password.errors && (password.dirty || password.valid || errorMsg)}">
            <div class="col-12 rp-xs">
              <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                <!--<div class="input-group-addon"><i class="fa fa-lock" aria-hidden="true"></i></div>-->
                <input class="form-control placeholder-custum heigh-50 border-radius-none" [type]="hidePassword?'password':'text'" value="" id="password" name="password" placeholder="MOT DE PASSE" [(ngModel)]="credentials.password"  #password="ngModel"  required>
                <i class="fa fa-eye input-icon" *ngIf="hidePassword" (click)="toglePasswordVisibility()"></i>
                <i class="fa fa-eye-slash input-icon" aria-hidden="true" *ngIf="!hidePassword" (click)="toglePasswordVisibility()"></i>
              </div>
              <div class="form-control-feedback"  *ngIf="password.touched && password.dirty && credentials.password.length<=0"><i class="fa fa-info-circle" aria-hidden="true"></i> {{'shared_login_form.your_password_is_required'| translate}}</div>
            </div>
          </div>
          <div class="text-left"><a routerLink="/login/forgot" class="password-fgt-color">Mot de pass oublié?</a></div>
          <!-- submit button -->
          <div class="form-group row submit-button-wrapper m-t-8p">
            <div class="rp-xs offset-sm-1 col-sm-10 text-center">
              <button type="submit" class="btn-color lg-btn">{{'shared_login_form.LOG_IN'| translate}}</button>
            </div>
          </div>
        </form>
     </div>
     <div class="center uppercase not-have-account">Vous n'avez pas encore de compte ? <a routerLink="/login/signup" class="color-gb">Inscrivez vous</a></div>
  </div>
  <div class="col-md-8 {{modePro?'bgImagePro':'bgImage'}} pd-lr-0 hide-second-bloc-mini"></div>
</div>





